import type { ItemStatus } from '@everplan/shared';
import { ITEM_STATUS_LABELS } from '@everplan/shared';

const STATUS_STYLES: Record<ItemStatus, string> = {
  not_started: 'bg-[var(--color-surface-container-high)] text-foreground',
  inquired: 'bg-[var(--color-secondary-container)] text-foreground',
  quoted: 'bg-[var(--color-primary-container)] text-foreground',
  contract_requested: 'bg-[var(--color-tertiary-container)] text-foreground',
  booked: 'bg-primary text-primary-foreground',
};

export default function StatusChip({ status }: { status: ItemStatus }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${STATUS_STYLES[status]}`}
    >
      {ITEM_STATUS_LABELS[status]}
    </span>
  );
}
